/* global grecaptcha */

const $ = require('jquery');

const DashboardSignup = {
	$form: [],
	errors: [],
	init() {
		this.$form = $('#dashboard-form');
		if ( this.$form.length > 0 ) {
			this.setup();
		}
	},
	setup() {
		this.$form.on('submit', this.onSubmit.bind(this));
		$(document).on('rapydGoogleRecaptchaCallback', this.onRecaptcha.bind(this));
	},
	buildData($form) {
		let data = { };
		$form.find('input,select,textarea').each( (i, el) => {
			const $$ = $(el);
			let name = $$.attr('name');
			if ( !name ) { return; }
			if ( name === 'g-recaptcha-response' ) {
				name = 'recaptcha_token';
			}
			if ( $$.attr('type') === 'checkbox' ) {
				data[name] = $$.is(':checked') ? $$.val() : '';
			} else {
				data[name] = $$.val();
			}
		} );
		return data;
	},
	onRecaptcha(event) {
		let data = this.buildData(this.$form);
		data['recaptcha_token'] = event.detail.token;
		this.postToDashboard(data);
	},
	onSubmit(event) {
		const $form = $(event.target);
		event.preventDefault();

		this.$button = $form.find('#dashboard-signup-submit');
		this.clearAllErrors($form);
		this.$button.prop('disabled', true);
		let data = this.buildData($form);
		data['IDV'] = false;
		data['plugin_registration_params'] = null;
		if ( this.isDataValid(data) ) {
			grecaptcha.execute();
		} else {
			this.showErrors($form);
			this.$button.prop('disabled', false);
		}
	},
	clearAllErrors($form) {
		this.errors = [];
		$form.find('span.error').remove();
		$form.find('[name].has-error').removeClass('has-error');
		$form.find('#captcha-element.has-error').removeClass('has-error');
	},
	clearSingleError(event) {
		const $$ = $(event.target);
		$$.removeClass('has-error');
		$$.parent().find('span.error').remove();
	},
	showErrors($form) {
		if ( this.errors.length === 0 ) { return; }

		this.errors.forEach( entry => {
			if ( entry.field === 'captcha' ) {
				$form.find('#captcha-element')
					.addClass('has-error')
					.append(`<span class="error">${entry.msg}</span>`)
				;
			} else {
				$form.find(`[name="${entry.field}"]`)
					.addClass('has-error')
					.one('blur', this.clearSingleError.bind(this))
					.after(`<span class="error">${entry.msg}</span>`)
				;
			}
		} );
	},
	isDataValid(data) {
		this.checkRequiredFields(data);

		if ( !this.isValidWebsite(data?.company_website) ) {
			this.errors.push({
				field: 'company_website',
				msg: 'Please enter a valid website URL',
			});
		}

		if ( !this.isValidPassword(data?.password) ) {
			this.errors.push({
				field: 'password',
				msg: 'Password not complex enough',
			});
		}

		if ( !this.passwordsMatch(data?.password, data?.confirm_password) ) {
			this.errors.push({
				field: 'confirm_password',
				msg: 'Confirm Password must match',
			});
		}

		// if ( !(data?.recaptcha_token) ) {
		// 	this.errors.push({
		// 		field: 'captcha',
		// 		msg: 'Please complete reCAPTCHA'
		// 	});
		// }

		return this.errors.length === 0;
	},
	checkRequiredFields(data) {
		const required_fields = [ 'sign_up_country', 'user_first_name', 'user_last_name', 'email', 'agree_to_terms_and_conditions' ];

		required_fields.forEach( field => {
			if ( !data[field] ) {
				this.errors.push({
					field,
					msg: 'Please enter required field',
				});
			}
		});
	},
	isValidWebsite(url) {
		const urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
			'(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
			'(\\#[-a-z\\d_]*)?$','i') // validate fragment locator
		;
		return !!urlPattern.test(url);
	},
	passwordsMatch(password, confirm_password) {
		return password == confirm_password;
	},
	isValidPassword(password) {
		return !!password?.match(/^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])|(?=.*[a-z])(?=.*[0-9])|(?=.*[A-Z])(?=.*[0-9])).{10,}$/);
	},
	clearError() {
		const $error_msg = this.errorMsg();
		$error_msg.removeClass('error');
		$error_msg.text('');
	},
	postToDashboard(data) {
		const url = 'https://dashboard.rapyd.net/v1/merchants-portal/users/sign-up';
		this.clearError();
		$.post({
			url,
			data: JSON.stringify(data),
			dataType: 'text',
			contentType: 'application/json',
			success: this.postSuccess.bind(this),
			error: this.postError.bind(this),
		});
	},
	postSuccess() {
		this.clearError();
		this.$form.hide();
		this.$form.after(
			$('<div><h3>Success!</h3><p>Thank you for creating an account with Rapyd. An email has been sent to your inbox with steps on how to get started.</p></div>')
		);
	},
	errorMsg() {
		let $error_msg = this.$form.find('#error_msg');
		if ( $error_msg.length === 0 ) {
			$error_msg = $('<div id="error_msg"></div>');
			this.$form.prepend($error_msg);
		}
		return $error_msg;
	},
	postError(xhr) {
		let response = {};
		let msg = 'There was an error submitting the form.';
		const $error_msg = this.errorMsg();
		try {
			response = JSON.parse(xhr.responseText);
			//$error_msg.addClass('error');
			if ( response?.status?.error_code === 'MERCHANT_PORTAL_USER_EXISTS' ) {
				msg += ' User already exists.';
			}
		} catch (e) {
			msg += ' Please check for CORS errors.';
		}
		$error_msg.text(msg);
		this.$button.prop('disabled', false);
	}
};
$(DashboardSignup.init.bind(DashboardSignup));
